var _path, _path2, _path3, _path4, _path5, _circle, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmptyStateAttachReceipt = function SvgEmptyStateAttachReceipt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 99,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DC80E4",
    stroke: "#002140",
    strokeMiterlimit: 10,
    d: "m1.224 98 3.908-5.136 4.242 5.024 4.465-4.8 4.91 4.69 5.358-5.025L28.682 98l4.8-5.135 5.581 4.576V56.029h28.91s4.13-.782 4.13-7.256V1.782l-5.47 4.689-4.354-5.357-4.354 5.357-4.91-5.024-5.025 5.246-4.129-5.246-4.13 5.135-4.91-4.354v21.544H8.59s-7.367 3.237-7.367 21.32v52.908Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#002140",
    d: "M39.063 56.03h26.009s-3.434-3.349-5.945-8.29c-2.51-4.938-8.707-23.69-13.393-23.69-4.687 0-6.615 6.947-6.615 12.223 0 5.276-.056 19.756-.056 19.756Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M45.817 23.882H8.479s-7.255 2.12-7.255 24.11L1 98l4.01-5.258L9.371 98l4.365-5.246L18.972 98l4.917-5.246L28.685 98l4.818-5.246 5.618 4.633V35.771c0-6.363 2.957-11.889 6.698-11.889 7.2 0 12.335 32.147 20.929 32.147 5.357 0 5.357-6.698 5.357-6.698V1.333M66.077 56.03h-26.79M34.823 23.883V1.782"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m34.823 1.781 4.91 4.911 4.019-5.357 4.354 5.47 4.647-5.47 4.955 5.246L62.392 1l4.298 5.637 5.415-5.302"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#002140",
    d: "M67.416 14.954H38.282v3.125h29.134v-3.125ZM50.115 27.621l1.73 3.07h15.402v-3.18l-17.132.11ZM55.081 37.78h12.224v3.517H56.533M6.917 33.202s-1.395 1.785-.67 3.907h27.515v-3.907H6.917ZM6.917 49s-1.395 1.785-.67 3.907h27.515V49H6.917ZM6.917 65s-1.395 1.785-.67 3.907h27.515V65H6.917Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 68,
    r: 15.5,
    fill: "#06D47C",
    stroke: "#002140"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFAF0",
    d: "M38.742 70.72s.306-.743.72-.764c.415-.022 4.677-.044 4.677-.044s.656-.263.546-.896c-.11-.633-.109-2.163-.109-2.163s-.218-.525-.698-.568c-.48-.044-4.261-.022-4.261-.022s-.372.198-.612-.175c-.24-.371-.24-1.07-.24-1.07l-.088-4.02s-.283-.504-.742-.524c-.459-.022-2.229.087-2.229.087s-.35.219-.415.284c-.065.065-.152 1.114-.152 1.114l.022 3.78s-.227.302-.481.437c-.253.135-4.392.152-4.392.152s-.583.123-.743.437c-.16.314-.197 2.338-.197 2.338s.24.59.722.765c.48.174 4.544.131 4.544.131s.502.371.569.611c.066.24-.022 4.48-.022 4.48s.46.632.984.677c.524.044 1.966-.045 1.966-.045s.635-.021.656-.786c.022-.765-.023-4.217-.023-4.217l-.002.001Z"
  })));
};
export default SvgEmptyStateAttachReceipt;